import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

// Components
import PageWrapper from 'components/PageWrapper'
import { HeaderContainer } from 'components/creditScore/ScoreHeaders'
import TextButton from 'components/textButton'
import RoundedIcon from 'components/RoundedIcon'
import { COMERCIOS_AFILIADOS_URL } from 'config'

// Assets
import {
  HelpIcon,
  CardDeposit,
  CardIcon,
  CardWithdraw,
  CardSuccess
} from 'assets/icons'
import flyingMoney from '../../assets/images/emojis/flying-money.png'
import affiliatedStores from '../../assets/images/affiliated-stores.png'

const ExtraCash = () => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_tarjeta_extra_cash' })
  }, [])

  return (
    <PageWrapper
      noTabBar
      mobileHeaderColor={1}
      viewSelected='/mis-tarjetas'
      title='Extraer dinero'
    >
      <section className='flex md:justify-center flex-col md:items-center md:max-w-[50rem] md:mx-auto'>
        <ExtraCashHeader />
        <div className='w-full flex flex-col md:grid-cols-2 md:grid gap-3 md:my-8 mt-3'>
          <CardInfo
            image={<CardDeposit />}
            text='Cargá dinero en tu billetera Wayni.'
          />
          <CardInfo
            image={<CardIcon />}
            text='Hacé una compra del monto que quieras con tu tarjeta física.'
          />
          <CardInfo
            image={<CardWithdraw />}
            text='Al pagar, decile al cajero que necesitas retirar dinero.'
          />
          <CardInfo
            image={<CardSuccess />}
            text='En tu ticket de compra verás reflejada la extracción.'
          />
        </div>
        <h3 className='text-center font-bold text-black mt-6'>
          Comercios adheridos
        </h3>
        <img
          src={affiliatedStores}
          className='mt-4 mb-6 max-w-96 mx-auto'
          alt='Carrefour, Farmacity, Vital'
        />
        <TextButton
          handleFunction={() => {
            trackEvent({ eventName: 'bille_boton_tarjeta_extra_cash_vermas' })
            window.open(COMERCIOS_AFILIADOS_URL, '_blank')
          }}
          className='text-xs text-center self-center'
        >
          ¡Ver más!
        </TextButton>
        <div className='flex items-center my-4 gap-2'>
          <HelpIcon variant='GREEN' />
          <p className='text-2xs md:text-xs text-black font-semibold'>
            Sujeto al tope diario de extracción fijado por el comercio.
          </p>
        </div>
      </section>
    </PageWrapper>
  )
}

export default ExtraCash

const ExtraCashHeader = () => (
  <HeaderContainer className='-mx-4 md:py-10 md:w-full' score={1}>
    <h2 className='mt-5 md:mt-0 font-semibold'>Monto máximo de extracción</h2>
    <div className='flex items-center gap-2 md:my-3'>
      <p className='font-extrabold text-[2.6875rem] my-3 sm:my-0'>$ 10.000</p>
      <img src={flyingMoney} alt='💸' />
    </div>
    <p className='text-xs leading-4'>
      en efectivo cada semana al realizar <br /> tus compras,{' '}
      <span className='font-bold'>¡en el acto y sin costos!</span>
    </p>
  </HeaderContainer>
)

const CardInfo = ({ image, text }: { image: JSX.Element; text: string }) => (
  <div className='bg-white rounded-[10px] min-w-[328px] w-full flex items-center p-3 gap-3'>
    <RoundedIcon icon={image} />
    <p className='text-black text-xs font-bold leading-4 mb-1'>{text}</p>
  </div>
)
